import { channelsOfCompanyListQuery } from '@/entities/company';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useChannelsOfCompanyList(companyId?: string) {
  const { data, ...otherQueryData } = useAppQuery({
    ...channelsOfCompanyListQuery(companyId!),
    enabled: !!companyId,
    customError: true,
  });

  return {
    channelsOfCompanyData: data?.channels.length ? data.channels : undefined,
    ...otherQueryData,
  };
}
